module.exports = __webpack_public_path__ + "img/icon-value-removed-icon-value-added.107fc110.svg";